import Model from '../Model';
export default class Notification extends Model {
  contentType() {
    return Model.attribute('contentType').call(this);
  }
  content() {
    return Model.attribute('content').call(this);
  }
  createdAt() {
    return Model.attribute('createdAt', Model.transformDate).call(this);
  }
  isRead() {
    return Model.attribute('isRead').call(this);
  }
  user() {
    return Model.hasOne('user').call(this);
  }
  fromUser() {
    return Model.hasOne('fromUser').call(this);
  }
  subject() {
    return Model.hasOne('subject').call(this);
  }
}
flarum.reg.add('core', 'common/models/Notification', Notification);